import * as React from "react";
import { forwardRef } from "react";
const SvgTriangleCircleIcon = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { id: "Layer_1", xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink", x: "0px", y: "0px", viewBox: "0 0 30 30", style: {
  enableBackground: "new 0 0 30 30"
}, xmlSpace: "preserve", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M15.5,28.3C8.1,28.3,2,22.3,2,14.8S8.1,1.3,15.5,1.3C22.9,1.3,29,7.4,29,14.8S22.9,28.3,15.5,28.3z M15.5,3.3 C9.2,3.3,4,8.5,4,14.8s5.2,11.5,11.5,11.5c6.3,0,11.5-5.2,11.5-11.5S21.8,3.3,15.5,3.3z" }), /* @__PURE__ */ React.createElement("polygon", { points: "22.1,14.4 13,20.9 13,7.9 " }));
const ForwardRef = forwardRef(SvgTriangleCircleIcon);
export { ForwardRef as ReactComponent };
